import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { BusinessUnitInfo } from '../../../message-models/business-unit.class';
import { OperativeInfo } from '../../../domain-model/operative-info.class';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { OperativesService } from '../../../operatives/services/operatives.service';
import { consts } from '../../../common/modals/consts';

@Component({
  selector: 'app-business-unit-assign',
  templateUrl: './business-unit-assign.component.html',
  styleUrls: ['./business-unit-assign.component.scss']
})
export class BusinessUnitAssignComponent implements OnInit {
  @Input() businessUnit: BusinessUnitInfo = new BusinessUnitInfo();
  @Input() allBusinessUnits: BusinessUnitInfo [] = [];
  @Input() heading = 'Assign Business Unit';
  @Input() helpText = '';
  @Output() choiceMade: EventEmitter<OperativeInfo[]> = new EventEmitter<OperativeInfo[]>();
  submitted = false;
  helpMessage: string = "";
  showingHelp = false;
  loadingOperatives: boolean = false;
  operatives: OperativeInfo[] = [];
  showMultiSelect: boolean = true;
  columns: any[];
  selectedOperatives: OperativeInfo[] = [];

  constructor(public modalRef: DynamicDialogRef,
    private errorHandlingService: ErrorHandlingService,
    private operativesService: OperativesService,
  ) { }

  ngOnInit(): void {
    this.helpMessage = this.helpText;
    this.initialiseColumnDataTableColumns();
    this.loadingOperatives = true;
    this.loadOperatives();
  }

  cancelClicked() {
    this.modalRef.close();
    this.choiceMade.emit(null);
  }

  saveClicked() {
    this.submitted = true;
    //No operatives selected
    if (this.selectedOperatives.length < 1) {
      return;
    }

    //set the BU for the selected operatives
    //this.selectedOperatives.forEach(operative => {
    //  operative.currentBusinessUnitId = this.businessUnit.id;
    //  operative.businessUnit = this.businessUnit.name;
    //});
    this.modalRef.close();
    this.choiceMade.emit(this.selectedOperatives);
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }

  initialiseColumnDataTableColumns() {
    this.columns = null;
    this.columns = [
      { field: 'firstName', header: 'First Name', type: 'text' },
      { field: 'lastName', header: 'Last Name', type: 'text' },
      { field: 'businessUnit', header: 'Current Business Unit', type: 'text' },      
    ];
  }

  private loadOperatives() {
    if (this.businessUnit?.companyId !== consts.emptyGuid) {
      this.operativesService.getOperativesInCompany(this.businessUnit.companyId, new Date().toISOString()).subscribe(operatives => {
        this.operatives = new Array<OperativeInfo>();
        this.operatives = operatives;

        this.operatives.forEach(o => {
          o.businessUnit = this.allBusinessUnits.find(f => f.id == o.currentBusinessUnitId)?.name;
        })

        this.loadingOperatives = false;
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
    };
  };
}
